// DONT EDIT THIS FILE. AUTOGENERATED. 
export enum AppTKeys {
	automaticallyLoggingInMessage = 'App.automaticallyLoggingInMessage',
	noPermission = 'App.noPermission',
}

// DONT EDIT THIS FILE. AUTOGENERATED. 
export enum GroupSelectionPageTKeys {
	active = 'GroupSelectionPage.active',
	createNewGroup = 'GroupSelectionPage.createNewGroup',
	demobEquipments = 'GroupSelectionPage.demobEquipments',
	getStarted = 'GroupSelectionPage.getStarted',
	idleEquipments = 'GroupSelectionPage.idleEquipments',
	manageMultipleYards = 'GroupSelectionPage.manageMultipleYards',
	managedByTenderdGroups = 'GroupSelectionPage.managedByTenderdGroups',
	masterGroup = 'GroupSelectionPage.masterGroup',
	myProjects = 'GroupSelectionPage.myProjects',
	noOfEquips = 'GroupSelectionPage.noOfEquips',
	noProjects = 'GroupSelectionPage.noProjects',
	project = 'GroupSelectionPage.project',
	projects = 'GroupSelectionPage.projects',
	projectsAndYards = 'GroupSelectionPage.projectsAndYards',
	repairEquipments = 'GroupSelectionPage.repairEquipments',
	searchProject = 'GroupSelectionPage.searchProject',
	viewDetails = 'GroupSelectionPage.viewDetails',
	workingEquipments = 'GroupSelectionPage.workingEquipments',
	yard = 'GroupSelectionPage.yard',
	yourGroups = 'GroupSelectionPage.yourGroups',
}

// DONT EDIT THIS FILE. AUTOGENERATED. 
export enum OnboardingPageTKeys {
	and = 'OnboardingPage.and',
	byClickingNext = 'OnboardingPage.byClickingNext',
	couldNotFetchUsers = 'OnboardingPage.couldNotFetchUsers',
	createYourAccount = 'OnboardingPage.createYourAccount',
	hello = 'OnboardingPage.hello',
	introDesc = 'OnboardingPage.introDesc',
	looksLikeYouHaveAnAccount = 'OnboardingPage.looksLikeYouHaveAnAccount',
	onboardYourTeam = 'OnboardingPage.onboardYourTeam',
	password = 'OnboardingPage.password',
	passwordRequirement = 'OnboardingPage.passwordRequirement',
	phoneNumberIsInvalid = 'OnboardingPage.phoneNumberIsInvalid',
	policy = 'OnboardingPage.policy',
	pricing = 'OnboardingPage.pricing',
	privacyPolicy = 'OnboardingPage.privacyPolicy',
	step1 = 'OnboardingPage.step1',
	step2 = 'OnboardingPage.step2',
	step3 = 'OnboardingPage.step3',
	termsAndConditions = 'OnboardingPage.termsAndConditions',
	unableToAddUsersPleaseRetryOnboarding = 'OnboardingPage.unableToAddUsersPleaseRetryOnboarding',
}

